import { loadStripe, type Stripe } from '@stripe/stripe-js'

const stripeKey = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY || ''
export const stripeMode = (import.meta.env.VITE_STRIPE_MODE || 'test') as 'test' | 'live'
export const isStripeConfigured = Boolean(stripeKey)
// Only warn when Stripe is genuinely wired up in test mode. With no key at all
// there is no sandbox to warn about, and the banner was rendering on production
// for every visitor because VITE_STRIPE_MODE defaults to 'test' when unset.
export const isStripeTestMode =
  isStripeConfigured && (stripeMode === 'test' || stripeKey.startsWith('pk_test_'))

// Safety: warn if mode and key prefix don't match
if (stripeKey && stripeMode === 'live' && stripeKey.startsWith('pk_test_')) {
  console.error('[stripe] VITE_STRIPE_MODE=live but key is pk_test_ — check your .env')
}
if (stripeKey && stripeMode === 'test' && stripeKey.startsWith('pk_live_')) {
  console.error('[stripe] VITE_STRIPE_MODE=test but key is pk_live_ — check your .env')
}

let stripePromise: Promise<Stripe | null> = Promise.resolve(null)
if (isStripeConfigured) {
  stripePromise = loadStripe(stripeKey)
}

export { stripePromise }
